import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { DocumentCodeCategory } from 'src/app/models/labels/document-code-category.model';
import { DocumentCode } from 'src/app/models/labels/document-code.model';
import { CommonState } from 'src/app/shared/services/common-state.service';

@Injectable({
  providedIn: 'root',
})
export class DocumentCodeService extends CommonState<DocumentCode> {
  constructor() {
    super(DocumentCode);
  }

  public findAllByCategory(category: DocumentCodeCategory) {
    return this.searchCollection('findAllByCategory', { params: { category } }).pipe(map((res) => res.resources));
  }
}
